export default () => {
    const map = document.querySelector('.js-map')

    if (!map) {
        return
    }

    // get coordinates from html data attribute
    let lat = 51.923272
    let lng = 4.9519519

    let latAddress1 = 51.933849349077285
    let lngAddress1 = 4.622392857670295

    // if (map.dataset.lat) {
    //   lat = parseFloat(map.dataset.lat);
    // }
    // if (map.dataset.lng) {
    //   lng = parseFloat(map.dataset.lng);
    // }

    // Google Maps kost circa 535 kB over 24 requests en stond op de
    // contactpagina het renderpad in de weg. Laad het pas als de kaart in
    // beeld komt; hij staat onder de vouw, dus dat scheelt de eerste render.
    const apiKey = 'AIzaSyD_TGotVN9tGlCY3N3sPcGYTcrlxMu2zVY'
    let geladen = false

    const laadMaps = () => {
        if (geladen) return
        geladen = true

        const script = document.createElement('script')
        script.src = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${apiKey}&callback=mapsCallback`
        document.body.appendChild(script)
    }

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries.some((e) => e.isIntersecting)) {
                    laadMaps()
                    observer.disconnect()
                }
            },
            { rootMargin: '300px' }
        )
        observer.observe(map)
    } else {
        laadMaps()
    }

    window.mapsCallback = () => {
        if (map) {
            window.addEventListener('resize', displayMap(lat, lng))
        }
    }



    const displayMap = (lat, lng) => {

        // google maps styling
        const styles = [
            {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [{ lightness: 10 }, { visibility: 'simplified' }],
            },
            {
                featureType: 'road',
                elementType: 'labels',
            },
        ]

        const coordinates = {
            lat: lat,
            lng: lng,
        }

        const options = {
            zoom: 10,
            center: new window.google.maps.LatLng(coordinates.lat, coordinates.lng),
            scrollwheel: false,
            draggable: true,
            zoomControl: true,
            scaleControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            styles: styles,
        }

        if (window.innerWidth < 500) {
            options.zoom = 9;
        }

        const map = new window.google.maps.Map(
            document.getElementById('maps'),
            options,
        )

        let icon = {
            url: '/wp-content/themes/voltens/img/marker@2x.png',
            scaledSize: new google.maps.Size(84, 112), // scaled size
        }

        const markerAddress1 = new window.google.maps.Marker({
            map: map,
            position: {
                lat: latAddress1,
                lng: lngAddress1,
            },
        })

        return markerAddress1
    }
}

// WEBPACK FOOTER //
// ./src/js/modules/Maps.js
